import Price from '~/libs/Price/Price';

import GeneralInformation from './GeneralInformation';
import mapCountryOfOrigin, { RawCountryOfOrigin } from './mapCountryOfOrigin';
import Reference from './Reference';

export interface RawReference {
	referenceBasketVersion: string;
	generalInformation: {
		productName: string | null;
		scientificName: string | null;
		concentration: string | null;
		pharmaceuticalForm: string | null;
		packSize: string | null;
		companyName: string | null;
	};
	proposedCifPrice: { value: string; currency: string } | null;
	countryOfOrigin: RawCountryOfOrigin;
}

export default function mapReference(reference: RawReference): Reference {
	return new Reference(
		reference.referenceBasketVersion,
		new GeneralInformation(
			reference.generalInformation.productName,
			reference.generalInformation.scientificName,
			reference.generalInformation.concentration,
			reference.generalInformation.pharmaceuticalForm,
			reference.generalInformation.packSize,
			reference.generalInformation.companyName
		),
		reference.proposedCifPrice !== null
			? new Price(reference.proposedCifPrice.value, reference.proposedCifPrice.currency)
			: null,
		mapCountryOfOrigin(reference.countryOfOrigin)
	);
}
